import React from 'react';

const TestStickyHeader: React.FC = () => {
  return (
    <div className="p-4">
      <h1 className="text-3xl font-bold mb-6">Test Sticky Header</h1>
      <p className="mb-4">This page contains a lot of content to test the sticky header functionality.</p>
      
      {/* Generate multiple sections with content to create scrollable page */}
      {Array.from({ length: 20 }).map((_, index) => (
        <div key={index} className="mb-10 p-6 bg-white rounded-lg shadow-md">
          <h2 className="text-2xl font-semibold mb-4">Section {index + 1}</h2>
          <p className="mb-4">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam aliquet felis nec erat volutpat, 
            eget ultrices nisi malesuada. Donec sit amet lacinia metus, vel lacinia libero. 
            Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae; 
            Nullam ac odio at urna congue bibendum non vel massa.
          </p>
          <p className="mb-4">
            Phasellus tempor sapien in turpis gravida, vel tempus odio vestibulum. 
            Suspendisse potenti. Cras dictum lobortis tortor, in varius felis tempus nec. 
            Curabitur sed erat a elit bibendum tincidunt. Nulla facilisi.
          </p>
          <p>
            Sed malesuada auctor massa, at suscipit urna vulputate vel. 
            Proin varius erat non velit sollicitudin, eget convallis nibh congue. 
            Suspendisse potenti. Morbi tincidunt dolor a volutpat congue.
          </p>
        </div>
      ))}
    </div>
  );
};

export default TestStickyHeader; 